import type { MessageInstance } from 'antd/es/message/interface';
import type { ModalStaticFunctions } from 'antd/es/modal/confirm';
import type { NotificationInstance } from 'antd/es/notification/interface';

const message: MessageInstance = new Proxy(
  {},
  {
    get(target: any, prop: string, receiver: any) {
      return function (...args: any[]) {
        if (typeof (window as any).__antd_message[prop] === 'function') {
          return (window as any).__antd_message[prop](...args);
        } else {
          throw new Error(`Method ${prop} is not defined on window.__antd_message`);
        }
      };
    },
  }
);
const notification: NotificationInstance = new Proxy(
  {},
  {
    get(target: any, prop: string, receiver: any) {
      return function (...args: any[]) {
        if (typeof (window as any).__antd_notification[prop] === 'function') {
          return (window as any).__antd_notification[prop](...args);
        } else {
          throw new Error(`Method ${prop} is not defined on window.__antd_notification`);
        }
      };
    },
  }
);
const modal: Omit<ModalStaticFunctions, 'warn'> = new Proxy(
  {},
  {
    get(target: any, prop: string, receiver: any) {
      return function (...args: any[]) {
        if (typeof (window as any).__antd_modal[prop] === 'function') {
          return (window as any).__antd_modal[prop](...args);
        } else {
          throw new Error(`Method ${prop} is not defined on window.__antd_modal`);
        }
      };
    },
  }
);

export { message, modal, notification };
